// import gsap from "gsap";

// import ScrollTrigger from "gsap/dist/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

document.querySelectorAll(".js-platform-flexibility").forEach((el) => {
    initOnScrollAnimation(el);
});
